import React, {Component} from 'react'
import { withTranslation } from 'react-i18next'
import axios from "./axios.js";
class Orientation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            pageContent:[]
        };
    }

    componentDidMount() {
      
}
async componentWillMount() {
	var language=localStorage.getItem('language')==null?'en':localStorage.getItem('language')     
    axios.get("/api/static_page?p=HowItWorks&language="+language, {}).then(res2 => {
      this.setState({
        pageContent: res2.data.data.content
      });
    });
  }
    

render() {
    const {t} = this.props
     return (
        <div>
        <div class="page-header">
      <div class="container">
         <div class="row">
            <div class="col-md-8">
               <h1 class="brcheading">{t('heading.how_it_works')}</h1>
            </div>
            <div class="col-md-4">
               <ol class="breadcrumb pull-right">
                  <li><a href="/">{t('heading.home')}</a></li>
                  <li class="active">{t('heading.how_it_works')}</li>
               </ol>
            </div>
         </div>
      </div>
   </div>
 
 <br />
 <div class="row">
  <div class="col-md-3">
  </div>
 <div class="col-md-6">
 <iframe width="100%" height="400" src="https://www.youtube.com/embed/Ar1Aeztuts4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
 </div>
 </div>
 <br />
 
   
    </div>
         )
         }
         }

export default withTranslation()(Orientation);